class CrocoAcademy {
  constructor(root) {
    this.root = root;
    this.filters = [...root.querySelectorAll('[data-academy-filter]')];
    this.courses = [...root.querySelectorAll('[data-academy-category]')];
    this.empty = root.querySelector('[data-academy-empty]');
    this.filters.forEach((button) => button.addEventListener('click', () => this.filter(button)));
    root.querySelectorAll('[data-academy-print]').forEach((button) => button.addEventListener('click', () => window.print()));
    ['sales', 'ticket', 'margin', 'commission'].forEach((name) => root.querySelector(`[data-academy-${name}]`)?.addEventListener('input', () => this.calculate()));
    this.calculate();
  }

  filter(button) {
    const category = button.dataset.academyFilter;
    this.filters.forEach((item) => {
      item.classList.toggle('is-active', item === button);
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });
    let visible = 0;
    this.courses.forEach((course) => {
      const show = category === 'all' || course.dataset.academyCategory.split(' ').includes(category);
      course.hidden = !show;
      if (show) visible += 1;
    });
    if (this.empty) this.empty.hidden = visible !== 0;
  }

  calculate() {
    const sales = Math.max(0, Number(this.root.querySelector('[data-academy-sales]')?.value || 0));
    const ticket = Math.max(0, Number(this.root.querySelector('[data-academy-ticket]')?.value || 0));
    const margin = Math.min(100, Math.max(0, Number(this.root.querySelector('[data-academy-margin]')?.value || 0)));
    const commission = Math.min(100, Math.max(0, Number(this.root.querySelector('[data-academy-commission]')?.value || 0)));
    const revenue = sales * ticket * 30;
    const profit = revenue * margin / 100;
    const locationShare = revenue * commission / 100;
    const language = document.documentElement.lang.toLowerCase().startsWith('en') ? 'en-GB' : 'es-ES';
    const format = new Intl.NumberFormat(language, { style: 'currency', currency: 'EUR' });
    const revenueNode = this.root.querySelector('[data-academy-revenue]');
    const profitNode = this.root.querySelector('[data-academy-profit]');
    const locationShareNode = this.root.querySelector('[data-academy-location-share]');
    if (revenueNode) revenueNode.textContent = format.format(revenue);
    if (profitNode) profitNode.textContent = format.format(profit);
    if (locationShareNode) locationShareNode.textContent = format.format(locationShare);
  }
}

const initCrocoAcademy = (scope = document) => scope.querySelectorAll('[data-academy]').forEach((root) => {
  if (!root.dataset.academyReady) {
    root.dataset.academyReady = 'true';
    new CrocoAcademy(root);
  }
});

document.addEventListener('DOMContentLoaded', () => initCrocoAcademy());
document.addEventListener('shopify:section:load', (event) => initCrocoAcademy(event.target));
